// TailAdmin Dashboard JavaScript
import Alpine from 'alpinejs'
import ApexCharts from 'apexcharts'

// Initialize Alpine.js
window.Alpine = Alpine
Alpine.start()

// Make ApexCharts available globally
window.ApexCharts = ApexCharts

// TailAdmin sidebar toggle
document.addEventListener('alpine:init', () => {
  Alpine.data('sidebar', () => ({
    sidebarOpen: false,
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen
    }
  }))

  // Dropdown component
  Alpine.data('dropdown', () => ({
    open: false,
    toggle() {
      this.open = !this.open
    },
    close() {
      this.open = false
    }
  }))
})